module.exports = __webpack_public_path__ + "img/brasilio.74171387.webp";